import { render } from "./addService.html?vue&type=template&id=637cd962&scoped=true&ts=true&external"
import script from "./AddService.vue?vue&type=script&lang=ts"
export * from "./AddService.vue?vue&type=script&lang=ts"

import "./AddService.vue?vue&type=style&index=0&id=637cd962&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637cd962"]])

export default __exports__